import { render, staticRenderFns } from "./PrescriptionInputForm.vue?vue&type=template&id=cebb70e2&scoped=true&"
import script from "./PrescriptionInputForm.vue?vue&type=script&lang=js&"
export * from "./PrescriptionInputForm.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionInputForm.vue?vue&type=style&index=0&id=cebb70e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebb70e2",
  null
  
)

export default component.exports